import { createSlice } from '@reduxjs/toolkit';
import reducers from './reducers';
import extraReducers from './extraReducers';
export * from '../../thunk/sessionConversion';

const SessionConversionSlice = createSlice({
    name: 'sessionConversion',
    initialState: {
        data: null,
        status: null,
        error: null,
        queryParams: {},
        cachedDays: {}, // { 'YYYY-MM-DD': { totalSessions, sessionsWithEvents, ... } }
    },
    reducers,
    extraReducers
});

const { actions, reducer } = SessionConversionSlice;
export const { setSessionConversionData, clearSessionConversionFilters } = actions;
export { reducer };

